export default function SyncableBatchChangeController(
  // pmSharedModelService
) {
  // const vm = this;

  _activate();

  function _activate() {
    // vm.change.tokenizedBody = pmSharedModelService.replaceTokens(vm.change.valueCurrent);
    // vm.change.tokenizedNewBody = pmSharedModelService.replaceTokens(vm.change.valueTo);
  }
}

SyncableBatchChangeController.$inject = [
  'pmSharedModelService',
];
